import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import RouteErrorBoundary from 'components/RouteErrorBoundary';
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';

// ==============================|| ROUTING RENDER ||============================== //

const ClinicAdminSetupPage = Loadable(lazy(() => import('pages/auth/ClinicAdminSetup')));

const PublicShortSetupTokenRoute = {
  path: '/setup/:token',
  element: <ClinicAdminSetupPage />,
  errorElement: <RouteErrorBoundary />
};

const PublicShortSetupRoute = {
  path: '/setup',
  element: <ClinicAdminSetupPage />,
  errorElement: <RouteErrorBoundary />
};

const PublicSCodeRoute = {
  path: '/s/:token',
  element: <ClinicAdminSetupPage />,
  errorElement: <RouteErrorBoundary />
};

const PublicClinicSetupRoute = {
  path: '/clinic-admin/setup',
  element: <ClinicAdminSetupPage />,
  errorElement: <RouteErrorBoundary />
};

const PublicClinicShortSetupRoute = {
  path: '/clinic/setup',
  element: <ClinicAdminSetupPage />,
  errorElement: <RouteErrorBoundary />
};

const PublicClinicRegisterRoute = {
  path: '/clinic-admin/register',
  element: <ClinicAdminSetupPage />,
  errorElement: <RouteErrorBoundary />
};

const router = createBrowserRouter(
  [
    PublicShortSetupTokenRoute,
    PublicShortSetupRoute,
    PublicSCodeRoute,
    PublicClinicSetupRoute,
    PublicClinicShortSetupRoute,
    PublicClinicRegisterRoute,
    LoginRoutes,
    MainRoutes
  ],
  { basename: import.meta.env.VITE_APP_BASE_NAME }
);

export default router;
